<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container">
      <div v-if="loading" class="loading-state">
        <div class="spinner"></div>
        <p>Đang tải dữ liệu...</p>
      </div>
      <div class="modal-header">
        <h2>Phân quyền</h2>
        <button class="btn-close" @click="$emit('close')">x</button>
      </div>

      <div class="modal-body" v-if="user">
        <div
          v-for="(group, groupName) in groupPermission(allPermissions)"
          :key="groupName"
          class="permission-group"
        >
          <p class="group-title">{{ groupName }}</p>
          <label v-for="p in group" :key="p.id" class="permission-item">
            <input
              type="checkbox"
              :check="selectedPermission.has(p.id)"
              @change="togglePermission(p.id)"
            />
            <span>{{ p.display_name }}</span>
          </label>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-outline" @click="$emit('close')">Huỷ</button>
        <button class="btn btn-primary" @click="handleSubmit">Lưu</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useToast } from "@/composables/useToast";
import { adminApi } from "@/services/api";
import { ref, toRefs, watch } from "vue";

const props = defineProps({
  user: Object,
  allPermissions: {
    type: Array,
    default: () => [],
  },
});
const { user } = toRefs(props);
const toast = useToast();
const emit = defineEmits(["close", "updated"]);
const loading = ref(false);
const selectedPermission = ref(new Set());
const groupPermission = (permissions = []) => {
  return permissions.reduce((acc, p) => {
    if (!acc[p.group]) acc[p.group] = [];
    acc[p.group].push(p);
    return acc;
  }, {});
};
watch(
  () => props.user,
  (user) => {
    selectedPermission.value.clear();
    if (user?.permissions) {
      user.permissions.forEach((p) => {
        selectedPermission.value.add(p.id);
      });
    }
  },
  { immediate: true },
);
const togglePermission = (id) => {
  if (selectedPermission.value.has(id)) {
    selectedPermission.value.delete(id);
  } else {
    selectedPermission.value.add(id);
  }
};
const handleSubmit = () => {
  const userID = user.value.id;
  console.log('User ID: ', userID);
  const permissionsToSave = Array.from(selectedPermission.value);
  loading.value = true;
  try {
    adminApi.assignPermissionUser(userID, {
      'permissions': permissionsToSave
    });
    emit("updated");
    toast.success("Gán quyền thành công");
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Có lỗi xảy ra";
    toast.error(errorMessage);
    console.log(error);
  } finally {
    loading.value = false;
  }
};
</script>
<style scoped>
.permission-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
  font-size: 14px;
  cursor: pointer;
}

.permission-item input {
  cursor: pointer;
}

.permission-group {
  margin-bottom: 16px;
  padding: 10px;
  border-radius: 10px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.group-title {
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: capitalize;
}
</style>
